import React from 'react';
import classNames from 'classnames';
import {
  HANDLE_CLASS,
  HANDLE_ACTIVE_CLASS,
  GRADIENT_STOPS_HANDLE_OFFSET_CSS_VAR,
} from '../constants';

export function Handle({ stop, handleProps, isActive, onCapture }) {
  const {
    ref: handleRef,
    className,
    offset,
    style,
    onBlur,
    onMouseDown,
    onTouchStart,
    ...rest
  } = handleProps;

  const styleWithVars = {
    ...style,
    [GRADIENT_STOPS_HANDLE_OFFSET_CSS_VAR]: `${offset}%`,
  };

  const setHandleRef = (node) => {
    if (node) {
      // rc-slider calls clickFocus when focus moves between handles during drag, which ends the drag; no-op here so drag continues.
      const el = node;
      el.clickFocus = () => {};
    }

    if (typeof handleRef === 'function') {
      handleRef(node);
    } else if (handleRef) {
      handleRef.current = node;
    }
  };

  const handleMouseDown = (e) => {
    if (e.button !== 0) {
      onMouseDown?.(e);

      return;
    }

    onCapture(stop.id);
    onMouseDown?.(e);
  };

  const handleTouchStart = (e) => {
    onCapture(stop.id);
    onTouchStart?.(e);
  };

  const handleBlur = (e) => {
    e.stopPropagation();
    onBlur?.(e);
  };

  return (
    <div
      {...rest}
      ref={setHandleRef}
      className={classNames(HANDLE_CLASS, className, { [HANDLE_ACTIVE_CLASS]: isActive })}
      style={styleWithVars}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onBlur={handleBlur}
    />
  );
}

Handle.displayName = 'Handle';
